<template>
  <div>
    <h3 class="title is-3">Reports</h3>
    <hr />
    <PoRequestByClientAndDateRange />
    <hr />
    <PoRequestReportByDateRange />
    <hr />
    <PurchaseOrderReportByDateRange />
    <hr />
    <DeliveryReportByDateRange />
    <hr />
    <BillingReportByDateRange />
  </div>
</template>

<script>
import PoRequestByClientAndDateRange from "../../components/Report/PoRequestByClientAndDateRange";
import PoRequestReportByDateRange from "../../components/Report/PoRequestReportByDateRange";
import PurchaseOrderReportByDateRange from "../../components/Report/PurchaseOrderReportByDateRange";
import DeliveryReportByDateRange from "../../components/Report/DeliveryReportByDateRange";
import BillingReportByDateRange from "../../components/Report/BillingReportByDateRange";
export default {
  components: {
    PoRequestByClientAndDateRange,
    PoRequestReportByDateRange,
    PurchaseOrderReportByDateRange,
    DeliveryReportByDateRange,
    BillingReportByDateRange
  }
};
</script>
